import React, {
  FC,
  useState,
  // CSSProperties,
  // memo,
  // useCallback,
  // useRef,
  MouseEvent,
  useEffect,
} from 'react';
import PitRadio from '../PitRadio/PitRadio';
import { Platform } from 'bimwin-api';
import styles from '../../styles/measure.module.scss';
import distanceImage from '../../assets/images/distance.png';
import distancehoverImage from '../../assets/images/distancehover.png';
import angleImage from '../../assets/images/angle.png';
import anglehoverImage from '../../assets/images/anglehover.png';
import areaImage from '../../assets/images/area.png';
import areaHoverImage from '../../assets/images/areahover.png';
import heightImage from '../../assets/images/height.png';
import heightHoverImage from '../../assets/images/heighthover.png';
import volumeImage from '../../assets/images/volume.png';
import volumeHoverImage from '../../assets/images/volumehover.png';
import deleteImage from '../../assets/images/delete.png';
import deleteHoverImage from '../../assets/images/deletehover.png';
import deleteLiImage from '../../assets/images/delete_li.png';
interface PitModuleMeasureProps {
  platform: Platform;
  distance?: number;
  elevation?: number;
  unit?: string; //mm
  type?: string; //3D
}
const PitModuleMeasure: FC<PitModuleMeasureProps> = ({
  platform,
  // distance,
  // elevation,
  // unit,//mm
  type = '3D', //3D
}) => {
  let [pCompany, setpCompany] = useState('mm');
  let [isShowBox, setisShowBox] = useState(1);
  // let [companyList] = useState([
  //   {
  //     value: "mm",
  //     lable: "毫米",
  //   },
  //   {
  //     value: "m",
  //     lable: "米",
  //   },
  //   {
  //     value: "km",
  //     lable: "千米",
  //   },
  // ]);
  let [btnType] = useState('distance');
  let [angle, setangle] = useState<any>([]);
  let [theMeasureOfArea, settheMeasureOfArea] = useState<any>([]);
  let [girth] = useState<any>([]);
  let [volume, setvolume] = useState<any>([]);
  let [measure, setmeasure] = useState<any>([]);
  // let [measureXYZ, setmeasureXYZ] = useState<any>([]);
  let [elevationLength, setelevationLength] = useState<any>([]);
  // let [time] = useState(null);
  let [chooseIndex, setchooseIndex] = useState(-1);
  let [xyzIndex, setxyzIndex] = useState(-1);
  const deleteMeasureData = (index: number, e: MouseEvent) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    platform.bimwin.plugins.measureTool.deleteData(index);
    switch (btnType) {
      case 'Angle': {
        setangle((pre: any) => {
          const arr = pre;
          arr.splice(index, 1);
          return [...arr];
        });
        break;
      }
      case 'distance': {
        setmeasure((pre: any) => {
          const arr = pre;
          arr.splice(index, 1);
          return [...arr];
        });
        if (type === '3D') {
          // setmeasureXYZ((pre: any) => [...pre.splice(index, 1)]);
        }
        break;
      }
      case 'TheMeasureOfArea': {
        settheMeasureOfArea((pre: any) => {
          const arr = pre;
          arr.splice(index, 1);
          return [...arr];
        });
        break;
      }
      case 'elevation': {
        setelevationLength((pre: any) => {
          const arr = pre;
          arr.splice(index, 1);
          return [...arr];
        });
        break;
      }
      case 'volume': {
        setvolume((pre: any) => {
          const arr = pre;
          arr.splice(index, 1);
          return [...arr];
        });
        break;
      }
      default:
        break;
    }
  };
  const radioChang = (value: string) => {
    setpCompany(value);
  };
  const setMeasureToolType = (type: string) => {
    platform.bimwin.plugins.measureTool.changeType(type);
  };
  const focusOn = (index: number) => {
    chooseIndex = index;
    setxyzIndex(index);
    let e: any = document.querySelector('.pit-measure-rangeBox');
    e.scrollTop = e.scrollHeight;
  };
  const setData = (value: string, obj: any) => {
    if (isShowBox === 1) {
      btnType = 'distance';
      chooseIndex = measure.length - 1;
      setmeasure((pre: any) => [...pre, { name: value, xyzData: obj }]);
      if (type === '3D') {
        let e: any = document.querySelector('.pit-measure-rangeBox');
        e.scrollTop = chooseIndex * 31 + 60;
      }
    }
    if (isShowBox === 6) {
      btnType = 'Angle';
      setangle((pre: any) => [...pre, value]);
      setTimeout(() => {
        setchooseIndex(angle.length - 1);
      }, 0);
    }

    if (isShowBox === 4) {
      btnType = 'elevation';
      chooseIndex = elevationLength.length - 1;
      setelevationLength((pre: any) => [...pre, value]);
      setTimeout(() => {
        focusOn(elevationLength.length - 1);
      }, 0);
    }

    if (isShowBox === 7) {
      btnType = 'volume';
      chooseIndex = elevationLength.length - 1;
      setvolume((pre: any) => [...pre, value]);
      setTimeout(() => {
        focusOn(volume.length - 1);
      }, 0);
    }

    if (isShowBox === 5) {
      btnType = 'TheMeasureOfArea';
      chooseIndex = elevationLength.length - 1;
      settheMeasureOfArea((pre: any) => [...pre, value]);
      setTimeout(() => {
        focusOn(theMeasureOfArea.length - 1);
      }, 0);
    }
  };
  const showBoxChange = (type: number, measurementType: string) => {
    setisShowBox(type);
    setMeasureToolType(measurementType);
  };
  const handleClickItem = (index: number, Itemtype: string) => {
    setchooseIndex(index);
    if (Itemtype === 'distance' || Itemtype === 'TheMeasureOfArea') {
      if (type === '3D') {
        platform.bimwin.plugins.measureTool.updateAssistant(index);
      }
      setxyzIndex(index === xyzIndex ? -1 : index);
    }
    if (Itemtype === 'volume') {
      platform.bimwin.plugins.measureTool.highLightVolume(index);
    }
    if (type === '3D') {
      platform.bimwin.plugins.measureTool.clickMove(index, Itemtype);
    }
  };
  useEffect(() => {
    platform.bimwin && setMeasureToolType('distance');
    platform.bimwin &&
      platform.bimwin.startMeasure((value: string, obj: any) => {
        setData(value, obj);
      });
    return () => {
      platform.bimwin && platform.bimwin.stopMeasure();
    };
  }, []);
  const distanceNode = measure.map((item: any, index: number) => {
    return (
      <li className={styles['pit-measure-distance']} key={index}>
        <span
          className={`${styles['pit-measure-value']} ${
            index === chooseIndex ? 'choosed' : ''
          }`}
          onClick={() => handleClickItem(index, 'distance')}
        >
          <span className={styles['pit-measure-value-left']}>
            <span className={styles['order']}>{index + 1}</span>
            距离：
          </span>
          <span className={styles['pit-measure-value-center']}>
            <span
              className={styles['true-number']}
              title={
                pCompany === 'mm'
                  ? Number(item.name).toFixed(2)
                  : pCompany === 'm'
                  ? Number(item.name / 1000).toFixed(2)
                  : Number(item.name / 1000000).toFixed(2)
              }
            >
              {pCompany === 'mm'
                ? Number(item.name).toFixed(2)
                : pCompany === 'm'
                ? Number(item.name / 1000).toFixed(2)
                : Number(item.name / 1000000).toFixed(2)}
            </span>
            <span className={styles['measure-unit']}>{pCompany}</span>
          </span>
          {index === chooseIndex ? (
            <img
              title="删除"
              className={styles['pit-measure-value-delete']}
              onClick={e => deleteMeasureData(index, e)}
              src={deleteLiImage}
            />
          ) : (
            ''
          )}
        </span>
        {type === '3D' && index === xyzIndex && btnType === 'distance' ? (
          <span className={styles['pit-measure-detail']}>
            <span className={styles['pit-measure-XYZ']}>
              <span className={styles['xyz']}>X: </span>
              <span className={styles['x-value']}>
                {pCompany === 'mm'
                  ? item.xyzData.x.toFixed(2)
                  : pCompany === 'm'
                  ? (item.xyzData.x / 1000).toFixed(2)
                  : (item.xyzData.x / 1000000).toFixed(2)}
              </span>
              <span className={styles['measure-unit']}>{pCompany}</span>
            </span>
            <span className={styles['pit-measure-XYZ']}>
              <span className={styles['xyz']}>Y: </span>
              <span className={styles['y-value']}>
                {pCompany === 'mm'
                  ? item.xyzData.y.toFixed(2)
                  : pCompany === 'm'
                  ? (item.xyzData.y / 1000).toFixed(2)
                  : (item.xyzData.y / 1000000).toFixed(2)}
              </span>
              <span className={styles['measure-unit']}>{pCompany}</span>
            </span>
            <span className={styles['pit-measure-XYZ']}>
              <span className={styles['xyz']}>Z: </span>
              <span className={styles['z-value']}>
                {pCompany === 'mm'
                  ? item.xyzData.z.toFixed(2)
                  : pCompany === 'm'
                  ? (item.xyzData.z / 1000).toFixed(2)
                  : (item.xyzData.z / 1000000).toFixed(2)}
              </span>
              <span className={styles['measure-unit']}>{pCompany}</span>
            </span>
          </span>
        ) : (
          ''
        )}
      </li>
    );
  });
  const angleNode = angle.map((item: any, index: number) => {
    return (
      <li className={styles['pit-measure-distance']} key={index}>
        <span
          className={`${styles['pit-measure-value']} ${
            index === chooseIndex ? styles['choosed'] : ''
          }`}
        >
          <span className={styles['pit-measure-value-left']}>
            <span className={styles['order']}>{index + 1}</span>
            角度：
          </span>
          <span className={styles['pit-measure-value-center']}>
            <span
              className={styles['true-number']}
              title={Number(item).toFixed(2)}
            >
              {Number(item).toFixed(2)}
            </span>
            <span className={styles['measure-unit']}>°</span>
          </span>
          {index === chooseIndex ? (
            <img
              onClick={e => deleteMeasureData(index, e)}
              title="删除"
              className={styles['pit-measure-value-delete']}
              src={deleteLiImage}
            />
          ) : (
            ''
          )}
        </span>
      </li>
    );
  });
  const elevationLengthNode = elevationLength.map(
    (item: any, index: number) => {
      return (
        <li className={styles['pit-measure-distance']} key={index}>
          <span
            className={`${styles['pit-measure-value']} ${
              index === chooseIndex ? styles['choosed'] : ''
            }`}
          >
            <span className={styles['pit-measure-value-left']}>
              <span className={styles['order']}>{index + 1}</span>
              高度：
            </span>
            <span className={styles['pit-measure-value-center']}>
              <span
                className={styles['true-number']}
                title={Number(item).toFixed(2)}
              >
                {Number(item).toFixed(2)}
              </span>
              <span className={styles['measure-unit']}>{pCompany}</span>
            </span>
            {index === chooseIndex ? (
              <img
                title="删除"
                className={styles['pit-measure-value-delete']}
                onClick={e => deleteMeasureData(index, e)}
                src={deleteLiImage}
              />
            ) : (
              ''
            )}
          </span>
        </li>
      );
    }
  );
  const volumeNode = volume.map((item: any, index: number) => {
    return (
      <li className={styles['pit-measure-distance']} key={index}>
        <span
          className={`${styles['pit-measure-value']} ${
            index === chooseIndex ? styles['choosed'] : ''
          }`}
        >
          <span className={styles['pit-measure-value-left']}>
            <span className={styles['order']}>{index + 1}</span>
            体积：
          </span>
          <span className={styles['pit-measure-value-center']}>
            <span
              className={styles['true-number']}
              title={Number(item).toFixed(3)}
            >
              {Number(item).toFixed(3)}
            </span>
            <span className={styles['measure-unit']}>{pCompany}³</span>
          </span>
          {index === chooseIndex ? (
            <img
              title="删除"
              className={styles['pit-measure-value-delete']}
              src={deleteLiImage}
            />
          ) : (
            ''
          )}
        </span>
      </li>
    );
  });
  const theMeasureOfAreaNode = theMeasureOfArea.map(
    (item: any, index: number) => {
      return (
        <li className={styles['pit-measure-distance']} key={index}>
          <span
            className={`${styles['pit-measure-value']} ${
              index === chooseIndex ? 'choosed' : ''
            }`}
          >
            <span className={styles['pit-measure-value-left']}>
              <span className={styles['order']}>{index + 1}</span>
              面积：
            </span>
            <span className={styles['pit-measure-value-center']}>
              <span
                className={styles['true-number']}
                title={Number(item).toFixed(3)}
              >
                {Number(item).toFixed(3)}
              </span>
              <span className={styles['measure-unit']}>{pCompany}²</span>
            </span>
            {index === chooseIndex ? (
              <img
                title="删除"
                className={styles['pit-measure-value-delete']}
                src={deleteLiImage}
              />
            ) : (
              ''
            )}
          </span>
          {index === xyzIndex && type === '2D' ? (
            <span className={styles['pit-measure-detail']}>
              <span className={styles['pit-measure-XYZ']}>
                <span className={styles['xyz']}>周长: </span>
                <span style={{ color: '#27deec' }}>
                  {girth[index].toFixed(3)}
                </span>
                <span
                  className={styles['measure-unit']}
                  style={{ padding: '0 6px' }}
                >
                  {pCompany}
                </span>
              </span>
            </span>
          ) : (
            ''
          )}
        </li>
      );
    }
  );
  return (
    <div className={styles['measureBoxSetUp']}>
      <div className={styles['btnBox']}>
        <div className={styles['pit-measure-button']}>
          <div
            className={`pit-button ${styles['measure-button']} ${
              isShowBox === 1 ? 'pit-checked' : ''
            }`}
            title="距离测量"
            onClick={() => showBoxChange(1, 'distance')}
          >
            <img className="imgInit img" src={distanceImage} />
            <img className="imgInit imgHover" src={distancehoverImage} />
          </div>
        </div>

        <div className={styles['pit-measure-button']}>
          <div
            className={`pit-button ${styles['measure-button']} ${
              isShowBox === 6 ? 'pit-checked' : ''
            }`}
            title="角度测量"
            onClick={() => showBoxChange(6, 'Angle')}
          >
            <img className="imgInit img" src={angleImage} />
            <img className="imgInit imgHover" src={anglehoverImage} />
          </div>
        </div>

        {type !== '3D' ? (
          <div className={styles['pit-measure-button']}>
            <div
              className={`pit-button ${styles['measure-button']} ${
                isShowBox === 5 ? 'pit-checked' : ''
              }`}
              title="面积测量"
              onClick={() => showBoxChange(5, 'TheMeasureOfArea')}
            >
              <img className="imgInit img" src={areaImage} />
              <img className="imgInit imgHover" src={areaHoverImage} />
            </div>
          </div>
        ) : (
          ''
        )}

        {type === '3D' ? (
          <div className={styles['pit-measure-button']}>
            <div
              className={`pit-button ${styles['measure-button']} ${
                isShowBox === 4 ? 'pit-checked' : ''
              }`}
              title="高度测量"
              onClick={() => showBoxChange(4, 'elevation')}
            >
              <img className="imgInit img" src={heightImage} />
              <img className="imgInit imgHover" src={heightHoverImage} />
            </div>
          </div>
        ) : (
          ''
        )}

        {type === '3D' ? (
          <div className={styles['pit-measure-button']}>
            <div
              className={`pit-button ${styles['measure-button']} ${
                isShowBox === 7 ? 'pit-checked' : ''
              }`}
              title="体积测量"
              onClick={() => showBoxChange(7, 'volume')}
            >
              <img className="imgInit img" src={volumeImage} />
              <img className="imgInit imgHover" src={volumeHoverImage} />
            </div>
          </div>
        ) : (
          ''
        )}
      </div>

      {isShowBox !== 6 ? (
        <div className={styles['pit-measure-unit']}>
          <PitRadio value={pCompany} label="mm" onChange={radioChang} />
          <PitRadio value={pCompany} label="m" onChange={radioChang} />
          <PitRadio value={pCompany} label="km" onChange={radioChang} />
        </div>
      ) : (
        ''
      )}

      {isShowBox === 6 ? (
        <div className={styles['pit-measure-unit-angle']} />
      ) : (
        ''
      )}

      <div className={`${styles['pit-measure-rangeBox']} pit-measure-rangeBox`}>
        {/* <!-- 距离测量 --> */}
        <ul
          className={styles['pit-measure-info']}
          style={{ display: isShowBox === 1 ? '' : 'none' }}
        >
          {distanceNode}
        </ul>

        {/* <!-- 最小距离 --> */}
        <ul
          className={styles['pit-measure-info']}
          style={{ display: isShowBox === 2 ? '' : 'none' }}
        >
          <li className={styles['pit-measure-distance']}>
            最小距离:
            <span className={styles['pit-measure-value']}>
              {Number(measure).toFixed(2)}
            </span>
            {pCompany === 'mm' ? 'mm' : pCompany === 'm' ? 'm' : 'km'}
          </li>
        </ul>

        {/* <!-- 角度测量 --> */}
        <ul
          className={styles['pit-measure-info']}
          style={{ display: isShowBox === 6 ? '' : 'none' }}
        >
          {angleNode}
        </ul>

        {/* <!-- 标高 --> */}
        <ul
          className={styles['pit-measure-info']}
          style={{ display: isShowBox === 4 ? '' : 'none' }}
        >
          {elevationLengthNode}
        </ul>

        {/* <!-- 体积 --> */}
        <ul
          className={styles['pit-measure-info']}
          style={{ display: isShowBox === 7 ? '' : 'none' }}
        >
          {volumeNode}
        </ul>

        {/* <!-- 面积测量 --> */}
        <ul
          className={styles['pit-measure-info']}
          style={{ display: isShowBox === 5 ? '' : 'none' }}
        >
          {theMeasureOfAreaNode}
        </ul>
      </div>

      <div className={styles['pit-measure-delete']}>
        <img className={styles['pit-delete-svg']} src={deleteImage} alt="" />
        <img
          className={styles['pit-delete-svg_hover']}
          src={deleteHoverImage}
          alt=""
        />
        <span className={styles['pit-delete-label']}> 删除全部 </span>
      </div>
    </div>
  );
};
export default PitModuleMeasure;
